module.exports = __webpack_public_path__ + "static/overview-smtp-config-5ee730c76b795097d2040a3da58ae6b6.png";